import * as angular from "angular";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Field } from "../../models/field.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { User } from "../../models/user.model";
import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { Limit } from "../../models/limit.model";

let CustomFieldComponent = {
    selector: "vcCustomFieldForm",
    templateUrl:
        "/angular/components/custom-fields/custom-field-form.component.html",
    bindings: {
        bindedField: "=?",
        mode: "=?",
    },
    controller: class CustomFieldForm {
        // * bindings for typescript compiler *
        public bindedField?: any;
        public mode?: string;
        // ************************************

        public types: any;
        public user: User;
        public selectedField: any;
        public loading = false;
        public field: Field;
        public limits: object;
        public activeCampaign: Campaign;
        public customFields: Field[];
        public editMode: boolean;
        public isLeaderView: boolean;
        public defaultOptions = {
            3: [
                { name: "True", value: "True" },
                { name: "False", value: "False" },
            ],
            6: [
                { name: "1 Star", value: 1 },
                { name: "2 Star", value: 2 },
                { name: "3 Star", value: 3 },
                { name: "4 Star", value: 4 },
                { name: "5 Star", value: 5 },
            ],
        };

        private __env: any;
        private dataProvider: FieldDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private userDataProvider: UserDataProvider;
        private limitDataProvider: LimitDataProvider;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        constructor(
            __env: any,
            FieldDataProvider: FieldDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            LimitDataProvider: LimitDataProvider,
            UserDataProvider: UserDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            __app_type: any
        ) {
            this.__env = __env;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.dataProvider = FieldDataProvider;
            this.userDataProvider = UserDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.limitDataProvider = LimitDataProvider;
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.types = this.dataProvider.getTypes();
            this.user = this.userDataProvider.getActiveUser();
            this.field = new Field();
            this.isLeaderView = __app_type == "LEADER";

            this.dataProvider.getAllFields().then(() => {
                this.customFields = this.dataProvider.customFields;
                this.customFields = this.customFields.filter((field: Field) => {
                    return !field.orgid;
                });
            });

            this.limitDataProvider.get().then((limits: Limit) => {
                this.limits = limits;
            });
        }

        $onInit() {
            angular.extend(this.field, this.bindedField);
            this.editMode = this.bindedField && !!this.bindedField.id;

            if (this.field && this.field.cftid == 2 && this.field.cfdefault)
                this.field.cfdefault = parseInt(this.field.cfdefault);

            if (!this.field.cftid) {
                this.field.cftid = 1;
            }

            console.log(this.field);
            this.selectedField = this.field;
            console.log(this.selectedField);
        }

        dismiss(): void {
            this.dialog.cancel();
        }

        saveField(field: Field): void {
            if (this.field.hokey) {
                this.saveRegularField(field);
            } else {
                if (!this.loading && field.isValid()) {
                    if (field.cfid) {
                        this.editField(field);
                    } else {
                        this.createField(field);
                    }
                }
            }
        }

        saveRegularField(selectedField: Field): void {
            if (!this.loading && this.field.isValid()) {
                this.loading = true;
                this.dataProvider.updateField(selectedField).then(
                    (editedField: Field) => {
                        angular.extend(this.field, editedField);
                        this.loading = false;
                        this.toast.success("Field Updated");
                        this.dialog.hide(editedField);
                    },
                    () => this.toast.error()
                );
            }
        }

        unsetDefaults(option: Array<any>): void {
            angular.forEach(this.field.options, (thisOption: any) => {
                if (!option || thisOption != option) {
                    thisOption.cfodefault = "0";
                }
            });
        }

        setDefault(option: any): void {
            if (this.field.cftid == 4) {
                this.unsetDefaults(option);
            }
            if (option.cfodefault == true || option.cfodefault == "1") {
                option.cfodefault = "0";
            } else {
                option.cfodefault = "1";
            }
        }

        editField(selectedField: Field): void {
            this.loading = true;
            this.dataProvider.updateCustomField(selectedField).then(
                (editedField: Field) => {
                    angular.extend(this.field, editedField);
                    this.loading = false;
                    this.toast.success("Field Updated");
                    this.dialog.hide(editedField);
                },
                (error: any) => this.toast.error(error)
            );
        }

        deleteField(field: Field, ev: any): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        bodyText: "It will be permanently deleted",
                        title: "Delete Custom Field?",
                    },
                })
                .then(() => {
                    this.dataProvider.deleteField(field).then(
                        () => this.toast.success("Field deleted"),
                        () => this.toast.error()
                    );
                });
        }

        createField(field: Field): void {
            this.loading = true;
            this.field.cfcreator = this.user.uid;
            this.dataProvider.createField(field).then(
                (newField: Field) => {
                    this.loading = false;
                    this.dialog.hide(newField);
                    this.toast.success("Field Created");
                },
                () => this.toast.error()
            );
        }

        addOption($event: any): void {
            let confirm = this.dialog
                .prompt()
                .title("Add multiple choice option")
                .placeholder("Option Name")
                .targetEvent($event)
                .multiple(true)
                .required(true)
                .ok("Add Choice")
                .cancel("Cancel");
            this.dialog
                .showPreConfiguredDialog(confirm)
                .then((result: string) => {
                    this.field.options.push({ cfoname: result });
                });
        }
    },
};

angular
    .module("customField", [])
    .component(CustomFieldComponent.selector, CustomFieldComponent);
